import type { OrderStatus } from '@khaddi/contracts';

/**
 * An offer accepted while the store is still brewing stays `new`/`brewing`, and
 * /shipper/home only reports `shipper_assigned`/`delivering` as `current`. We
 * remember the accepted order locally so the shipper isn't shown fresh offers
 * (and can find their order again) until the store finishes brewing.
 */
const KEY = 'khaddi.shipper.activeOrder';

export const OPEN_FOR_SHIPPER: OrderStatus[] = ['new', 'brewing', 'awaiting_shipper', 'shipper_assigned', 'delivering'];

export const readActiveOrderId = (): string | null => {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const rememberActiveOrder = (orderId: string | null): void => {
  try {
    if (orderId) window.localStorage.setItem(KEY, orderId);
    else window.localStorage.removeItem(KEY);
  } catch {
    // private mode: the home banner falls back to /shipper/home's `current`
  }
};
